<template>
	<UiGridTile>No Products</UiGridTile>
</template>